import { supabase } from '@/integrations/supabase/client';

export const migrateRelicStorage = async (bulletinId: string) => {
  try {
    const { data, error } = await supabase.functions.invoke('migrate-relic-storage', {
      body: { bulletinId }
    });

    if (error) {
      console.error('Error migrating relic storage:', error);
      return { success: false, error };
    }

    return { success: true, data };
  } catch (error) {
    console.error('Error calling migrate-relic-storage function:', error);
    return { success: false, error };
  }
};